(function () {
  /* Le reveal au scroll est géré globalement par guticafe-reveal.js (chargé dans
     theme.liquid sur toutes les pages) — pas besoin de le dupliquer ici. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduceMotion) {
    var parallaxEls = document.querySelectorAll('[data-parallax]');
    if (parallaxEls.length) {
      var ticking = false;
      var updateParallax = function () {
        parallaxEls.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          var progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
          var shift = (progress - 0.5) * 60;
          el.style.transform = 'translateY(' + shift.toFixed(1) + 'px) scale(1.08)';
        });
        ticking = false;
      };
      var onScroll = function () {
        if (!ticking) { window.requestAnimationFrame(updateParallax); ticking = true; }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      updateParallax();
    }
  }
})();
